import * as React from 'react';
import Paper from '@mui/material/Paper';
import { Box, Stack, Zoom } from '@mui/material';
import ParentBox from 'pages/components/ParentBox';
import { adjustAlpha, repeatEffect, settingsConfig } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import BaseMapView from 'map/BaseMapView';
import CommonBoundaryLayer from 'map/layers/CommonBoundaryLayer';
import CommonHeatmapLayer from 'map/layers/CommonHeatmapLayer';
import { ToFeatures } from 'services/GeoJsonService';
import BaseTitleBox from 'pages/components/BaseTitleBox';
import CommonMarkerLayer from 'map/layers/CommonMarkerLayer';
import ColorInfoBox from 'pages/components/ColorInfoBox';
import PlaceIcon from '@mui/icons-material/Place';
//import VisibilityIcon from '@mui/icons-material/Visibility';

const colorTraffic = "rgb(150, 150, 150)"
const colorsTaas = ["rgb(255,245,0)", "rgb(255, 60, 53)", "rgb(150, 150, 150)"]
const colorsDangerVehicle = ['rgb(136, 221,0)', 'rgb(9, 188, 113)', 'rgb(21, 158, 188)', 'rgb(70, 177, 254)']
export default function TrafficTaasView() {
    const mapRef = React.useRef();
    const [currentData1, setCurrentData1] = React.useState()
    const [currentData2, setCurrentData2] = React.useState()
    const [currentData3, setCurrentData3] = React.useState()

    React.useEffect(() => {
        if (mapRef.current) {
            const map = mapRef.current.GetOlMap();

            map.addLayer(new CommonBoundaryLayer(map));

            const layerTraffic = new CommonMarkerLayer(map)
            map.addLayer(layerTraffic);

            const heatmaplayer = new CommonHeatmapLayer({
                blur: 0.5,
                radius: 4,
                gradient: colorsDangerVehicle
            });
            map.addLayer(heatmaplayer)

            const layerTaas = new CommonMarkerLayer(map)
            map.addLayer(layerTaas);

            return repeatEffect(
                async () => {
                    const response = await ApiService.get("newdashboard/trfsfty/GetDangerVehicleChart");
                    if (response.status === 200) {
                        const data = response.data;
                        const maxAvgTrf = data?.dayTraffic?.maxAvgTrf >= 1000 ? (data.dayTraffic.maxAvgTrf / 1000).toFixed() * 1000 : 1000

                        setCurrentData1({
                            labels: [
                                `${Number((maxAvgTrf / 4).toFixed()).toLocaleString()}대+`,
                                `${Number((maxAvgTrf / 2).toFixed()).toLocaleString()}대+`,
                                `${Number((maxAvgTrf).toFixed()).toLocaleString()}대+`
                            ]
                        })
                        setCurrentData2()
                        layerTraffic.clear()
                        heatmaplayer.clear()
                        layerTaas.clear()

                        layerTraffic.add(
                            ToFeatures(data.dayTraffic.rows).map(feature => {
                                const properties = feature.get('properties');
                                if (properties) {
                                    const radius = 20 * properties.avgTrf / maxAvgTrf;

                                    // 사각형 크기에 따라 색상 다르게 설정
                                    let fillColor = 'rgb(255,0,0)'; // 가장 큰 사각형 (빨강)
                                    if (radius < 6) {
                                        fillColor = 'rgb(173, 16, 204)'; // 가장 작은 사각형 (파랑)
                                    } else if (radius < 12) {
                                        fillColor = 'rgb(255,245,0)'; // 중간 크기 사각형 (노랑)
                                    }

                                    feature.setStyle(layerTraffic.getTriangleStyle({ // 트라이앵글로 쓰긴했는데 사각형임. 
                                        fillColor: adjustAlpha(fillColor, 0.7),
                                        strokeColor: adjustAlpha(fillColor, 1.0),
                                        zIndex: 1,
                                        size: radius, 
                                    }))
                                }
                                return feature;
                            })
                        );

                        heatmaplayer.add(ToFeatures(data.dangerVehicle.rows, { heatmapValue: 1.0 / 4 }));

                        setCurrentData2({ labels: ['1건', '2건', '3건', '4건+'] })
                        var death1 = layerTaas.getBoxStyle({
                            fillColor: adjustAlpha(colorsTaas[0], 1.0),
                            storkeColor: adjustAlpha(colorsTaas[0], 1.0),
                            radius: 6,
                            zIndex: 2
                        })
                        var death1Plus = layerTaas.getBoxStyle({
                            fillColor: adjustAlpha(colorsTaas[1], 1.0),
                            storkeColor: adjustAlpha(colorsTaas[1], 1.0),
                            radius: 6,
                            zIndex: 3
                        })

                        // setCurrentData3({ labels: ['사망 발생 지점', '사상자 발생 지점'], minDate: data.minDate, maxDate: data.maxDate })
                        // const groupCount = { value1: 0, value2: 0, value3: 0 }
                        // layerTaas.add(
                        //     ToFeatures(data.taas.rows)
                        //         .map(feature => {
                        //             const properties = feature.get('properties');
                        //             if (properties) {
                        //                 if (properties.deathCount > 1) {
                        //                     feature.setStyle(death1Plus)
                        //                     groupCount.value2++;
                        //                 } else {
                        //                     feature.setStyle(death1)
                        //                     groupCount.value1++;
                        //                 }
                        //             }
                        //             return feature
                        //         }))
                    }
                },
                settingsConfig().contentUpdateDelaySec)
        }
    }, [mapRef]);

    return (
        <ParentBox sx={{ position: 'relative', overflow: 'hidden' }}>
            <Box sx={{ width: '100%', height: '100%', position: 'absolute', left: '-13%', top: '-3%' }}>
                <BaseMapView
                    ref={mapRef}
                    initViewData={{ zoom: 12.34, center: [127.06, 37.29] }}
                />
            </Box>
            <Stack sx={{ position: 'absolute', right: '0', top: '30px', width: '680px', height: '80%' }}
                direction="column"
                justifyContent="center"
                alignItems="stretch">
                <Paper variant='outlined' sx={{ width: '100%', p: 3, borderRadius: '32px', background: 'var(--gs-90)', flex: 1 }}>
                    <Stack sx={{ width: '100%', height: '100%' }}
                        direction="column"
                        justifyContent="center"
                        alignItems="stretch"
                        spacing={4}>

                        {currentData1 &&
                            <LegendBox
                                title={`대형차량 교차로 교통량 (일 누적)`}
                                sx={{ fontSize: '36px', background: 'rgba(255,255,255,0.05)' }}
                            >
                                {currentData1.labels.map((p, idx) =>
                                    <ColorInfoBox
                                        key={idx}
                                        color={idx === 0 ? 'rgb(173, 16, 204)' : idx === 1 ? 'rgb(255,245,0)' : 'rgb(255,0,0)'}
                                        width={10 * (idx + 1)}
                                        height={10 * (idx + 1)}
                                        text={p}
                                        shape="triangle"
                                    />)}
                            </LegendBox>
                        }

                        {currentData2 &&
                            <LegendBox title={`위험물 차량 위치 분포도 (일 누적)`}>
                                {currentData2.labels.map((p, idx) =>
                                    <ColorInfoBox key={idx} color={adjustAlpha(colorsDangerVehicle[idx], (idx + 1) * 0.40)} width={30} height={30} text={p} isCircle />)}
                            </LegendBox>
                        }

                    </Stack>
                </Paper>
            </Stack>
        </ParentBox>
    )
}

const LegendBox = ({ title, children, sx }) => {
    return (
        <Zoom in>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{
                    backgroundColor: 'var(--white-05)',
                    p: 2,
                    borderRadius: '20px',
                    ...sx,
                }}>
                <BaseTitleBox variant={5} sx={{ width: '100%', backgroundColor: 'var(--white-05)', borderRadius: '10px', }} align="left" icon={<PlaceIcon />}
                    title={title} />
                <Stack sx={{ width: '100%' }}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={5}>
                    {children}
                </Stack>
            </Stack>
        </Zoom>
    )
}